import { makeStyles, shorthands, tabClassNames, tokens } from '@fluentui/react-components';
import { customPalette } from '../theme';

export const useDrillDownStyles = makeStyles({
    header: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        margin: '0px 6px',
    },
    errorMessage: {
        boxSizing: 'content-box',
        color: customPalette.red,
        fontSize: '12px',
        margin: '10px 6px 0',
        padding: '0 0 5px',
    },
    drillDownTabPanelContainer: {
        paddingBottom: '24px',
        minHeight: '10em',
        flexGrow: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    tabPanel: {
        minHeight: '10vh',
        // needed in order to center the loading spinner
        height: '100%',
    },
    tabBarRow: {
        display: 'flex',
        gap: '8px',
        padding: '0 6px',
        alignItems: 'center',
    },
    tabList: {
        flexGrow: 1,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        alignSelf: 'stretch',
    },
    tabButton: {
        // Override Fluent tab content color via parent selector (avoids !important)
        [`& .${tabClassNames.content}`]: {
            color: `${customPalette.neutralTertiaryAlt}`,
        },
        padding: '6px',
        ':after': {
            height: '2px',
            left: '8px',
            right: '8px',
        },
        ':hover': {
            ':before': {
                height: '2px',
                left: '8px',
                right: '8px',
            },
        },
    },
    spinnerIcon: {
        paddingLeft: '5px',
        opacity: 0.5,
    },
    // This is to keep same look/feel from Fluent8 and also to keep it better aligned with inner text;
    // Using "20Regular" Fluent9 icons with custom height/width of 16px
    icon: {
        width: '16px',
        height: '16px',
    },
    iconOnlyButton: {
        backgroundColor: tokens.colorNeutralBackground1,
        border: `1px solid ${customPalette.neutralSecondaryAlt}`,

        boxShadow: '0px 5px 4px -4px rgba(0, 0, 0, 0.02), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
        padding: '0',
        height: '25px',
        width: '25px',
        minWidth: 'unset',
        ':hover': {
            color: customPalette.themePrimary,
            ...shorthands.borderColor(customPalette.themePrimary),
        },
        ':disabled': {
            backgroundColor: customPalette.neutralLighter,
            color: customPalette.neutralTertiary,
            pointerEvents: 'none',
        },
    },
});
